import React from 'react';
import ConfiguratorOptionsDescriptionDisplay from './descriptionDisplay.js';
import Select from 'react-select';

export default class ConfiguratorOptionsList extends React.Component {

	// вычисляются перед рендером
	selected_link_price = null
	groupHasCounts = false
	totalSelectedQty = 0
	refDiv = null
	commonSelectedQty = null // одно для всех выбранное количео - работает когда количества связаны
	
	setStateP(opt) { return new Promise(resolve => this.setState(opt, resolve)) }
	
	constructor(props) {
		super(props);
		this.state = {
			selectedCounts: {},
			displayMessages: false,
		}
		this.refDiv = React.createRef();
	}
	
	// выбрана ли эта сслыка?
	linkSelected(link : object|null) : boolean {
		if(!link)
			return !this.props.selected || this.props.selected.length === 0;
		if(!this.props.selected) return false;
		return !!this.props.selected.find(v => Object.values(link.counts).includes(v));
	}
	
	getLinkById(id : number) : object | null {
		for(let link of this.props.items)
			if(link.id === id)
				return link;
		return null;
	}
	
	selectedLinks() : object | null {
		let ret = [];
		for(let link of this.props.items)
			if(this.linkSelected(link))
				ret.push(link);
		return ret;
	}
	
	// какая считалка количества выбрана для данной ссылки?
	countSelectedValue(link: object) : number {
		let manualId = this.state.selectedCounts[link.id];
		if(manualId) return manualId;
		
		let defaultId = Object.values(link.counts)[0];
		if(!this.props.selected) return defaultId;
			
		let selectedId = this.props.selected.find(v => Object.values(link.counts).includes(v));
		if(selectedId) return selectedId;
		
		return defaultId;
	}
	
	// количества для всех ссылок, эквивалентные этому
	// в виде, пригодном для установки в selectedCounts
	getAllCountsEqualTo(value, link) {
		let qty = Object.keys(link.counts).find(c => link.counts[c] === value);
		if(!qty) return [];
		let ret = {};
		for(let link of this.props.items)
			if(link.counts[qty])
				ret[link.id] = link.counts[qty];
		return ret;
	}
	
	onCountsChange(qty, link) {
		this.setStateP(state => {
			state.selectedCounts[link.id] = link.counts[qty];
			return {
				selectedCounts: state.selectedCounts,
				displayMessages: true,
			};
		})
		.then(() => this.onLinkChange(link, true));
	}
	
	onLinkChange(link: object|number|null, setValue: boolean|null) {
		
		if(link && typeof link === 'number')
			link = this.getLinkById(link)
		
		if(setValue === null) setValue = this.linkSelected(link);
		
		// заготовка нового массива значений
		let newSelected = [];
		// просто пустой массив если это не множественный выбор или ссылка пустая (клик по not-included)
		if(this.props.multiple && link)
		{
			// копия старого значения минус все элементы из этого линка
			newSelected = this.props.selected.filter(v => !Object.values(link.counts).includes(v));
		}
			
		if(link && setValue)
			newSelected.push(this.getLinksCountId(link))

		if(this.props.onChange)
			this.props.onChange(newSelected);
		
		this.setStateP({
			displayMessages: true,
		});
	}
	
	// цена выбранного пункта (абсолютная)
	getLinkPrice(link) {
		
		let qty = this.getLinkDisplayQty(link);
		if(link.price_type === 'percent_whole')
		{
			let price = parseFloat(link.price);
			if(!this.props.base_price) return {
				value: 0,
				type: 'percent_whole',
			};
			return {
				value: 0.01 * this.props.base_price * price * qty,
				type: 'percent_whole',
			};
		}
		
		let displayPrice = null;
		let priceType = null;
		if(this.props.pricesOverride)
		{
			priceType = "override";
			displayPrice = this.props.pricesOverride[link.counts[qty]];
		}
		if(!displayPrice)
		{
			priceType = "general";
			displayPrice = link.actual_price;
		}
		if(displayPrice === null) return {value: 0, type: priceType};
		
		let price = displayPrice * qty;
		if(this.props.included_price)
			price -= this.props.included_price;
		
		return {value: price, type: priceType};
	}
	
	// количесто, которое надо показывать (даже если не выбрано)
	getLinkDisplayQty(link) : number {
		let qty = this.getLinkSelectedQty(link);
		if(qty) return qty;
		
		const allQtys = Object.keys(link.counts).map(v => parseInt(v));
		if(allQtys.length === 0)
			return 1; // нет количеств - значит простой элемент, значит 1
		if(this.commonSelectedQty)
			return this.commonSelectedQty; // если есть общее количество - показываем его
		
		return Math.min(...allQtys); // наименьшее
	}
	
	// количество, которое выбрано
	getLinkSelectedQty(link) : number {
		// все количества
		const allQtys = Object.keys(link.counts).map(v => parseInt(v));
		// только выбранные
		const qtys = allQtys.filter(c => this.props.selected.includes(link.counts[c]));
		if(qtys.length > 0)
			return qtys[0]; // если нашлось - возвращаем
		return 0; // не выбрано
	}
	
	// вернуть id количества, соответствующее данной ссылке
	// если не выбрано или нет данных - вернуть минимальное (первое в списке)
	getLinksCountId(link : object) : number {
		// если была напрямую выбрана
		if(this.state.selectedCounts[link.id])
			return this.state.selectedCounts[link.id];
		
		const linkIds = Object.values(link.counts);
		// если всего одна
		if(linkIds.length === 1)
			return linkIds[0];
		
		// если была выбрана ранее
		let id = this.props.selected.find(v => linkIds.includes(v));
		if(id) return id;
		
		return linkIds[0];
	}
	
	preCountRenderValues() {
		this.selected_link_price = null;
		this.groupHasCounts = false;
		this.totalSelectedQty = 0;
		
		this.commonSelectedQty = null;
		let countsAreLinked = !this.props.multiple; // только для одиночного выбора
		let countsSignature = null;
		
		for(let link of this.props.items)
		{
			let selectedQty = this.getLinkSelectedQty(link);
			
			let linkHasCounts = true;
			
			switch(Object.values(link.counts).length)
			{
				case 0:
					console.log("invalid configuration", link);
				break;
				case 1:
					linkHasCounts = Object.keys(link.counts)[0] !== "1";
				break;
				default:
					linkHasCounts = true;
				break;
			}
			
			// сумма всего, что выбрано
			this.totalSelectedQty += selectedQty;
			
			// selected_link_price
			if(this.selected_link_price === null && this.linkSelected(link))
			{
				const price = this.getLinkPrice(link).value;
				if(price)
					this.selected_link_price = price;
			}
			
			// groupHasCounts
			if(linkHasCounts)
				this.groupHasCounts = true;
			
			// countsAreLinked
			if(countsAreLinked)
			{
				if(linkHasCounts)
				{
					let sig = Object.keys(link.counts).sort().join('/');
					if(countsSignature === null)
						countsSignature = sig;
					else if(countsSignature !== sig)
						countsAreLinked = false;
				}
				else
				{
					countsAreLinked = false;
				}
			}
			if(selectedQty)
				this.commonSelectedQty = selectedQty;
		}
			
		if(!countsAreLinked)
			this.commonSelectedQty = null;
			
		return null
	}
	
	renderErrorMessage(message) {
		if(message === 'required_empty')
			return 'This is a required field.';
		if(message === 'max_qty_exceeded')
			return `max qty ${this.props.max_qty} (${this.totalSelectedQty} selected)`;
		return message;
	}
	
	render() {
		
		if(this.props.scrollTo)
			setTimeout(() => {
				this.refDiv.current.scrollIntoView({ behavior: 'smooth' });
			}, 100);
		
		this.preCountRenderValues();
		
		const displayMessages = this.props.displayMessages || this.state.displayMessages;
		
		return (
		<div className={`group-body ${this.props.className||''}`} ref={this.refDiv}>
			<div className="bs__row">
				<div className="bs__col-md-3 bs__col-sm-2 bs__col-xs-3">
					{this.props.image ? 
					<img 
						src={this.props.image_crop}
						srcSet={this.props.image_crop2x}
						loading="lazy"
						alt={this.props.title}
						width="174"
						height="174"
					/>
					: null}
				</div>
				<div className="group-title xs bs__col-xs-9">
					{this.props.title}
					{this.props.customSubtitle}
				</div>
				<div className="bs__col-md-9 bs__col-sm-10">
					<div>
						<div className="group-title hidden-xs">
							{this.props.title}
							{this.props.customSubtitle}
						</div>
						<ConfiguratorOptionsDescriptionDisplay html={this.props.short_descr}/>
						<ConfiguratorOptionsDescriptionDisplay html={this.props.long_descr} long/>
					</div>
					
					{(displayMessages && this.props.messages) ? <ul className="error-messages">
						{this.props.messages.map(message => <li key={message}>
							{this.renderErrorMessage(message)}
						</li>)}
					</ul>: null}
					
					{/* className={`options ${(displayMessages && this.props.messages) ? 'errors' : ''}`} */ }
					
					<ul className="options">
						{this.lis()}
					</ul>
				</div>
			</div>
		</div>
		)
	}
	
	lis() {
		
		let lis = [];
		
		if(!this.props.is_required)
		{
			const linkSelected = this.linkSelected(null);
			
			let className = ['item'];
			if(linkSelected) className.push('selected');
		
			lis.push(
				<li key="not-included" className={className.join(' ')}>
					<span onClick={e => linkSelected ? null : this.onLinkChange(null, true)}>
						Not included
					</span>
				</li>
			);
		}
		
		let groupedItems = {};
		for(let link of this.props.items)
		{
			let group_title = link.group || "default";
			if(link.archived)
				group_title = "Archived";
			if(!groupedItems[group_title])
				groupedItems[group_title] = [];
			groupedItems[group_title].push(link);
		}
		
		const groupTitles = Object.keys(groupedItems)
			.sort((a, b) => Number(a === "Archived") - Number(b === "Archived"));
		
		for(let subtitle of groupTitles)
		{
			if(subtitle !== 'default')
				lis.push(<li key={`subtitle-${subtitle}`} className="subtitle">{subtitle}</li>);
			
			for(let link of groupedItems[subtitle])
			{
				if(link.admin && !this.props.adminMode) continue;
				const linkSelected = this.linkSelected(link);
				
				let className = ['item'];
				if(linkSelected) className.push('selected');
				if(link.block) className.push('blocked');
				if(link.className) className.push(link.className);
				if(link.archived) className.push('archived');
				
				const linkPrice = this.getLinkPrice(link);
				if(linkPrice.type === "override")
					className.push("price-override");
				
				let price = linkPrice.value;
				if(!this.props.multiple && this.selected_link_price)
					price -= this.selected_link_price;
				
				const counts = (this.groupHasCounts && !link.block) ? Object.keys(link.counts) : null;
				
				const selectedCount = this.getLinkDisplayQty(link) || null;
				
				let tooltip = null;
				let onClick = () => this.onLinkChange(link, !linkSelected);
				if(link.block) onClick = null;
				
				lis.push(
					<li key={`${link.id}-${Object.values(link.counts).join('-')}`} className={className.join(' ')}>
						{counts ?
							counts.length === 1
							? <div 
								className="counts"
								onClick={onClick}
							>{counts[0]}x</div>
							:<Select
								className="counts-rs-container"
								classNamePrefix="counts-rs"
								onChange={val => this.onCountsChange(parseInt(val.value) || null, link)}
								value={{
									value: selectedCount,
									label: selectedCount ? `${selectedCount}x` : '',
								}}
								options={counts.map(c => ({value: c, label: `${c}x`}))}
								isSearchable={false}
							/>
						 : null}
						<span onClick={onClick} title={tooltip}>
							<span dangerouslySetInnerHTML={{__html:link.option ? link.option.name : link.title}}></span>
							{link.recomended ? <div className="badge badge-warning">Recommended</div> : null}
							{link.sale ? <div className="badge badge-danger">Promo</div> : null}
							{link.block ? null : <b className="price-display">
								{price >= 0 ? '+' : '-'}
								{this.props.currencyDisplay(Math.abs(price))}
							</b>}
						</span>
					</li>
				);
			}
		}
		
		return lis;
	}
}